module.exports = {
          srcSet: __webpack_public_path__ + "public/images/e60eb7404f7d077a34532a65c3cd8cc1-1920.webp"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/e60eb7404f7d077a34532a65c3cd8cc1-1920.webp",width: 1920,height: 1280}],
          src: __webpack_public_path__ + "public/images/e60eb7404f7d077a34532a65c3cd8cc1-1920.webp",
          toString:function(){return __webpack_public_path__ + "public/images/e60eb7404f7d077a34532a65c3cd8cc1-1920.webp"},
          
          width: 1920,
          height: 1280
        }